import _ChevronDownIcon from "@adsk/alloy-react-icon/es/lib/ChevronDownIcon";
const _excluded = ["style", "isOpen", "getToggleButtonProps", "highlightButtonOnFocus", "as"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import React from 'react';
import { BasicButton } from '@adsk/alloy-react-button';
import theme from '@adsk/alloy-react-theme';
const ToggleButton = _ref => {
  let {
      style,
      isOpen,
      getToggleButtonProps,
      highlightButtonOnFocus,
      as
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const toggleButtonProps = (getToggleButtonProps === null || getToggleButtonProps === void 0 ? void 0 : getToggleButtonProps(props)) || props;
  return /*#__PURE__*/React.createElement(BasicButton, _extends({
    "data-testid": 'Control__toggle',
    as: as,
    style: _objectSpread({
      padding: 0,
      height: 32,
      cursor: props.disabled ? 'not-allowed' : undefined
    }, highlightButtonOnFocus && !isOpen && {
      '&:focus-within': {
        svg: {
          boxShadow: theme.halos.focus,
          borderRadius: theme.borderRadius.small
        }
      }
    })
  }, toggleButtonProps), /*#__PURE__*/React.createElement(_ChevronDownIcon, {
    style: [_objectSpread({
      color: theme.tokens.colors.icon.primary.value
    }, isOpen && {
      transform: 'rotate(180deg)'
    }), style]
  }));
};
export default ToggleButton;
//# sourceMappingURL=ToggleButton.js.map